import { render, staticRenderFns } from "./addcountUsdt.vue?vue&type=template&id=c0c0b4d4&scoped=true"
import script from "./addcountUsdt.vue?vue&type=script&lang=js"
export * from "./addcountUsdt.vue?vue&type=script&lang=js"
import style0 from "./addcountUsdt.vue?vue&type=style&index=0&id=c0c0b4d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c0b4d4",
  null
  
)

export default component.exports